import { makeAutoObservable } from 'mobx';
import { ITag, TagPicker } from '@fluentui/react';
import { observer } from 'mobx-react';
import API, { ISharePointSiteResult, ISiteAndTeamSearchResult, ITeamSearchResult } from '../../API';
import { createRef } from 'react';
import { IUserConfigPackage } from '../../API';

export interface ISiteOrTeam extends ITeamSearchResult, ISharePointSiteResult {}

export class SearchSitesAndTeamsState {

	userConfig: IUserConfigPackage;
	
	searchBoxElement = createRef<HTMLDivElement>();
	
	isCalloutVisible: boolean = false;
	onSelect: (selection?: ISiteOrTeam) => void;
	results: ISiteOrTeam[] = [];
	
	selected?:ISiteOrTeam;
	
	public toggleIsCalloutVisible() {
		this.isCalloutVisible = !this.isCalloutVisible;
	}

	constructor(
		userConfig:IUserConfigPackage,
		onSelect:(selection?:ISiteOrTeam) => void
	) {
		this.onSelect = onSelect;
		this.userConfig = userConfig;	
		makeAutoObservable(this);
	}
	
	public async getSearchResultags(query:string) : Promise<ITag[]> {
		if(query.indexOf(".sharepoint.com") > 0) {

			this.results = [{
				id: '',
				webUrl: query,
				displayName: ''
			}];

			return Promise.resolve([{
				name: 'Content URL: ' + query,
				key: query,
			}]);
		} else {
			let token = await this.userConfig.getToken();
			let result = await new API(token).siteAndTeamSearch(query || '');
			this.results = this.getSitesOrTeams(result).sort((r1, r2) => {return r1.displayName > r2.displayName ? 1 : -1  });	
		}

		return this.results.map(r => this.getTagFromItem(r));
	}

	public getTagFromItem(r:ISiteOrTeam) :ITag {
		return {
			name: (r.id ? 'Team' : 'Site') + ': ' + (r.displayName || r.webUrl),
			key: r.id || r.webUrl
		};
	}
	
	public getSitesOrTeams(result:ISiteAndTeamSearchResult):ISiteOrTeam[] {
		return (result.sites as any[]).concat(result.teams as any[]);
	}

	public selectionChanged (selectedItem?: ITag) {

		var item = this.results.find(r => r.id === selectedItem?.key || r.webUrl === selectedItem?.key);
		this.onSelect(item);
		this.selected = item;
		return null;
	}

}

function SearchSitesAndTeams({
	state
}: {
	state: SearchSitesAndTeamsState;
}) {

	return (<>
			<div ref={state.searchBoxElement}>
				{/*<SearchBox onChange={state.onSearchTextChange.bind(state)} />*/}
				<TagPicker
					removeButtonAriaLabel="Remove"
					onResolveSuggestions={state.getSearchResultags.bind(state)}
					onChange={items => { state.selectionChanged(items ? items[0] : undefined) }}
					resolveDelay={300}
					getTextFromItem={tag => tag.name}
					itemLimit={1}
					pickerCalloutProps={{ doNotLayer: false }}
					selectedItems={state.selected ? [state.getTagFromItem(state.selected)] : []}
					onItemSelected={state.selectionChanged.bind(state)}
				/>
			</div>
		</>
	);
}

export default observer(SearchSitesAndTeams);
